import { AxiosResponse } from 'axios';
import { BaseNimbleAPI } from '../../../api/baseAPI';
import { ExpressInterestWaitlistResponse } from './types';

class ExpressInterestWaitlistAPI extends BaseNimbleAPI {
  async getSchoolsUserIsOnWaitlistFor(): Promise<ExpressInterestWaitlistResponse[]> {
    const response: AxiosResponse = await this.get(
      '/api/connect_school_connection_request_waitlist/'
    );
    return response.data;
  }

  async addToWaitlist(schoolNcesId: string): Promise<ExpressInterestWaitlistResponse> {
    const url = '/api/connect_school_connection_request_waitlist/';
    const payload = {
      school_nces_id: schoolNcesId,
    };

    const response: AxiosResponse = await this.post(url, payload);
    return response.data;
  }
}

export default new ExpressInterestWaitlistAPI();
